import { AxiosRequestHeaders } from 'axios';

import { config } from 'config/env-config';

const envUrl = config.env.url;
const envLayerSeven = config.env.layerSeven;
const envHelpAndSupport = config.env.helpAndSupport;

export const trackUiAppId = 'my-post-consumer-track-ui';

export const myPostBaseUrl = envUrl + '/mypost';

export const myPostTrack = '/mypost/track/';
export const myPostTrackDetails = myPostTrack + 'details/';
export const myPostTrackSearch = myPostTrack + 'search';

// Help and support
export const extLnkHelpAndSupportBase = envUrl + '/help-and-support';
export const extLnkHelpAndSupport = envUrl + '/help';
export const extLnkHelpAndSupportStarTrack = 'https://startrack.com.au/support';
export const extLnkMyPostSafeDropTerms = envUrl + '/terms-conditions/mypost-safe-drop-terms-and-conditions';
export const extLnkContextualHelp = extLnkHelpAndSupportBase + '/contextual-help/?articleId=';
export const extLnkDeliveryIssues = extLnkHelpAndSupport;
export const extLnkNotTrackableFAQ = extLnkHelpAndSupport + '/answers?s=what+does+product+not+trackable+mean';
export const extLnkCheckID = extLnkHelpAndSupport + '/answers?s=000010251';
export const extLnkOwnershipFAQ = extLnkHelpAndSupport + '/answers?s=13347';
export const extLnkInvalidID = extLnkHelpAndSupport + '/answers?s=000003988';
export const extLnkMissingItemLoggedIn = envHelpAndSupport + '/s/missing-or-lost-item-authenticated?trackingId=';
export const extLnkMissingItem = envHelpAndSupport + '/s/missing-or-lost-item?trackingId=';
export const extLnkPending = extLnkHelpAndSupport + '/answers?s=pending';
export const extLnkLiiaspFAQ = extLnkHelpAndSupport + '/answers?s=000033499';

export const extLnkPostOfficeLocator = envUrl + '/locate';
export const extLnkPostOfficeLocatorWithShowpop = envUrl + '/locate/showpop/';
export const extLnkCollectMissedDelivery = envUrl + '/receiving/collecting-missed-deliveries';
export const internationalDestinationGuide = envUrl + '/service-updates/international-delivery-times';

export const attemptedDeliveryPhotos = extLnkHelpAndSupport + '/answers?s=000039339';

// Account
export const extLnkNotificationPref = envUrl + '/account/personal/focus/preferences/notifications';
export const extLnkDeliveryPref = envUrl + '/account/personal/preferences/delivery';

// Mypost
export const extLnkMyPostRedirect = myPostBaseUrl + '/redirect/#/';
export const extLnkMyPostRedirectV2 = myPostBaseUrl + '/parcel-redirect';
export const extLnkMyPostSafeDrop = myPostBaseUrl + '/safeplace/offer';
export const extLinkMyPostDelegationUI = myPostBaseUrl + '/nominate/';
export const extLnkCollectionNomination = (trackingId: string) => extLinkMyPostDelegationUI + trackingId;

// External
export const extLnkFeedbackSurvey =
  'https://survey.auspost.com.au/cgi-bin/qwebcorporate.dll?idx=2EU4HK&n_LaunchPage=Track%20React';

export const appChannel = {
  detail: 'WEB_DETAIL',
  search: 'WEB_SEARCH',
  watchList: 'WEB_WATCHLIST',
  multiRemove: 'WEB_MULTI_REMOVE',
};

export const apiEndpoint = {
  // Customer API
  auth0: 'https://digitalapi.auspost.com.au/medium',

  // Shipment API
  shipmentsV1: envLayerSeven + '/shipments-gateway/v1/watchlist/shipments',
  shipmentEdd: envLayerSeven + '/shipment-edd/v1/shipments',

  // Nicknames API
  nicknames: envLayerSeven + '/nicknames/v2',

  // Delivery Preference API
  deliveryPreferencesV2: envLayerSeven + '/delivery-preferences/v2/preferences',

  // Redirect API
  postcodeLookup: envLayerSeven + '/postcode/search',

  // Article Notification Subscription API
  notificationSubscriptionAuthed: envLayerSeven + '/subscription/v2/article',

  // Location v3 API
  locationWorkCentre: envLayerSeven + '/locations-private/v3/workcentres',

  apiKeys: config.api,
};

export const screenBreakpoints = {
  xs: 0,
  sm: 480,
  md: 680,
  lg: 970,
  xl: 1170,
  xxl: 1600,
};

export const getAuthUIParams = (nextHref: string) =>
  '?caller=TRACK&product=MYPOST_CONSUMER&channel=WEB&next=' + encodeURIComponent(nextHref);

export const APP_REQUEST_CONFIGS = {
  get generic() {
    return {
      headers: { 'Content-Type': 'application/json' } as AxiosRequestHeaders,
      withCredentials: true,
    };
  },
  get shipment() {
    return {
      headers: {
        'api-key': apiEndpoint.apiKeys.shipmentsGateway,
        'Content-Type': 'application/json',
        AP_CHANNEL_NAME: 'WEB',
      } as AxiosRequestHeaders, // todo double check AP_CHANNEL_NAME
      withCredentials: true,
    };
  },
};

export const CommonClass = {
  FULLSTORY_MASK: 'fullstory-mask',
};

// Test track config invalidation
